import React from 'react';
import Icon from '../../../components/AppIcon';


const CategoryFilter = ({ 
  selectedCategory = 'all', 
  onCategoryChange, 
  templateCounts = {},
  className = '' 
}) => {
  const categories = [
    { 
      id: 'all', 
      label: 'All Templates', 
      icon: 'Grid3x3',
      color: 'text-text-primary'
    },
    { 
      id: 'birthday', 
      label: 'Birthday', 
      icon: 'Gift',
      color: 'text-accent'
    },
    { 
      id: 'follow-up', 
      label: 'Follow-up', 
      icon: 'Clock',
      color: 'text-primary'
    },
    { 
      id: 'holiday', 
      label: 'Holiday', 
      icon: 'Calendar',
      color: 'text-success'
    },
    { 
      id: 'custom', 
      label: 'Custom', 
      icon: 'Edit',
      color: 'text-secondary'
    }
  ];

  return (
    <div className={`${className}`}>
      {/* Mobile Horizontal Scroll */}
      <div className="lg:hidden">
        <div className="flex space-x-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories?.map((category) => {
            const isActive = selectedCategory === category?.id;
            const count = templateCounts?.[category?.id] || 0;
            
            return (
              <button
                key={category?.id}
                onClick={() => onCategoryChange(category?.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-full whitespace-nowrap transition-micro ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-card'
                    : 'bg-surface text-text-secondary border border-border hover:bg-muted hover:text-text-primary'
                }`}
              >
                <Icon 
                  name={category?.icon} 
                  size={16} 
                  className={isActive ? 'text-current' : category?.color} 
                />
                <span className="font-medium">{category?.label}</span>
                {count > 0 && (
                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                    isActive 
                      ? 'bg-primary-foreground text-primary' 
                      : 'bg-muted text-text-secondary'
                  }`}>
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
      {/* Desktop Vertical List */}
      <div className="hidden lg:block">
        <h3 className="text-lg font-semibold text-text-primary mb-4">Categories</h3>
        <div className="space-y-1">
          {categories?.map((category) => {
            const isActive = selectedCategory === category?.id;
            const count = templateCounts?.[category?.id] || 0;
            
            return (
              <button
                key={category?.id}
                onClick={() => onCategoryChange(category?.id)}
                className={`w-full flex items-center justify-between px-4 py-3 rounded-lg transition-micro hover-lift ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-card'
                    : 'text-text-secondary hover:bg-muted hover:text-text-primary'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <Icon 
                    name={category?.icon} 
                    size={18} 
                    className={isActive ? 'text-current' : category?.color} 
                  />
                  <span className="font-medium">{category?.label}</span>
                </div>
                {count > 0 && (
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    isActive 
                      ? 'bg-primary-foreground text-primary' 
                      : 'bg-muted text-text-secondary'
                  }`}>
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {/* Quick Stats */}
        <div className="mt-6 p-4 bg-muted rounded-lg">
          <h4 className="font-medium text-text-primary mb-3">Quick Stats</h4>
          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-text-secondary">Total Templates</span>
              <span className="font-medium text-text-primary">
                {Object.values(templateCounts)?.reduce((sum, count) => sum + count, 0)}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-text-secondary">Most Used</span>
              <span className="font-medium text-text-primary">Birthday</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-text-secondary">Last Created</span>
              <span className="font-medium text-text-primary">2 days ago</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;